import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { 
  Box,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'

const Navigation = () => {
  const theme = useTheme()
  const location = useLocation()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [mobileOpen, setMobileOpen] = useState(false)

  const navItems = [
    { label: 'Certificate Onboard', path: '/' },
    { label: 'Bulk Upload', path: '/bulk-upload' },
    { label: 'Certificates', path: '/aws-certificates' },
    { label: 'CRQs', path: '/crqs' },
    { label: 'Onboarding ITSM Products', path: '/product-dl' },
  ]

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const drawer = (
    <Box sx={{ width: 280, pt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 2, pb: 1 }}>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={NavLink}
              to={item.path}
              onClick={handleDrawerToggle}
              sx={{
                '&.active': {
                  backgroundColor: 'primary.main',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  }
                }
              }}
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )

  if (isMobile) {
    return (
      <>
        <Box 
          sx={{ 
            backgroundColor: 'primary.main',
            py: 1,
            px: 2,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open navigation"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ color: 'white' }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ ml: 2, color: 'white', fontSize: '16px' }}>
            Menu
          </Box>
        </Box>
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>
      </>
    )
  }

  return (
    <Box 
      sx={{ 
        backgroundColor: 'primary.main',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Box className="container mx-auto">
        <Tabs
          value={false}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              color: 'white',
              textTransform: 'none',
              fontSize: '14px',
              minHeight: '44px',
              borderLeft: '1px solid #4b95db',
              '&:first-of-type': {
                borderLeft: 'none',
              },
              '&:hover': {
                backgroundColor: 'white',
                color: 'primary.dark',
              },
              '&.active': {
                backgroundColor: 'white',
                color: 'primary.dark',
              }
            },
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          {navItems.map((item) => {
            const isActive = location.pathname === item.path
            return (
              <Tab
                key={item.path}
                label={item.label}
                component={NavLink}
                to={item.path}
                className={isActive ? 'active' : ''}
              />
            )
          })}
        </Tabs>
      </Box>
    </Box>
  )
}

export default Navigation
